import React, { Component } from "react";
import ColegiaturasTabla from "./ColegiaturasTabla";
import { connect } from "react-redux";
import { getColegiaturasList } from './ColegiaturasAction'
import { withRouter } from 'react-router-dom';

class ColegiaturasContainer extends Component {

    componentDidMount() {
        //console.log("ColegiaturasContainer");
        this.props.dispatch(getColegiaturasList());
    }

    render() {
        return (
            <div>
                <ColegiaturasTabla />
            </div>
        );
    }

}

export default connect()(ColegiaturasContainer);
